export default "__VITE_ASSET__kX6p9x9K__"